import React, { Component } from 'react';

declare var globalSns;
declare var globalExtranet;

class ExtranetSubNav extends Component {
  constructor(props) {
    super(props);

    this.navigate = this.navigate.bind(this);
  }

  navigate(id, e) {
    this.props.onSubNavigate(id);
  }

  render() {
    if (this.props.activeSubNav == null) {
      return "";
    }
    return (
      <section id="subnav" className="row subnav">
        <ul className="subnav">
          {
            this.props.activeSubNav.map((x) => 
              <li key={x.id} className={x.id === this.props.activeComponent ? "active": ""}>
                <a onClick={(e) => this.navigate(x.id, e)}>
                  {x.title} {x.nr ?  "(" + x.nr + ")": ""}
                  {x.id === this.props.activeComponent ? <span className="sr-only">(current)</span> : ""}
                </a>
              </li>
            )
          }        
        </ul>
      </section>
    );
  }
}

export default ExtranetSubNav;


// WEBPACK FOOTER //
// ./src/Components/Extranet/ExtranetSubNav.js